export default __webpack_public_path__ + "static/g3-25692cfc24792dd92d21dda44cd95ebd.jpg";